import { HT_INFO_PHONE } from '@constants/hellotech';
import { makeRatingJsonLd } from '@utils/jsonLd/rating';
import { makeOpeningHoursJsonLd } from '@utils/jsonLd/hours';
import { makeSpecificItemJsonLd } from '@utils/jsonLd/skuItem';
import { LocationPageProps, SkuData } from '@scenes/LocationPage/locationPage.types';

type MakeLocalBusinessJsonLdProps = {
  name: string;
  description: string;
  location: string;
  rating?: LocationPageProps['ratingAttributes'];
  skuData?: SkuData;
};

export const makeLocalBusinessJsonLd = ({ skuData, rating, name = '', description = '', location = '' }: MakeLocalBusinessJsonLdProps) => ({
  type: 'LocalBusiness',
  name: `HelloTech ${name}`,
  description,
  image: 'https://www.hellotech.com/HT-sharing-logo.png',
  telephone: HT_INFO_PHONE.customers.default.title,
  address: {
    streetAddress: '',
    addressLocality: location,
    postalCode: '',
    addressCountry: 'US',
  },
  sameAs: ['www.hellotech.com'],
  ...makeRatingJsonLd(rating),
  ...makeOpeningHoursJsonLd(),
  ...makeSpecificItemJsonLd(skuData),
});
